import { required } from 'vuelidate/lib/validators';
export const address = {
    id: 0,
    countryUuid: '',
    city: '',
    name: '',
    postcode: '',
    street: '',
    buildingNumber: '',
    buildingName: '',
    unitNumber: '',
    isDefault: false,
};
export const addressValidators = {
    countryUuid: {
        required,
    },
    city: {
        required,
    },
    postcode: {
        required,
    },
    street: {
        required,
    },
    buildingNumber: {
        required,
    },
    unitNumber: {
        required,
    },
    name: {},
    buildingName: {},
};
